<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >

    <v-btn
      class="ma-2"
      :color="activeRestaurant  == restaurant.id ? '#26A69A' : 'rgb(10, 128, 116)' "
      tile
      @click="setActiveRestaurant(restaurant.id)" v-for="restaurant in restaurants"
      :key="restaurant.id"
    >
      {{restaurant.title}}
    </v-btn>
    <v-btn
      v-if="activeRestaurant"
      style="float:right"
      @click="createReservation()"
      small
      title="Создать Бронь"
      color="warning"
      dark
      top
      right
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <filter-app @changeFilter='changeFilter' class="white v-sheet mb-2"></filter-app>
    <v-data-table
      v-if="activeRestaurant"
      :headers="headers"
      :items="reservations"
      disable-sort
      disable-filtering
      disable-pagination
      hide-default-footer
      height=""
      class="elevation-1"
    >

      <template v-slot:item.tablesNumber="{ item }">
        <v-chip
          color="purple darken-3"
          style="color: white;font-weight: 600;   font-size: 16px;"
          class="ma-2"
          :key="i"
          v-for="t in item.tablesNumber"
        >
         <strong> {{t}}</strong>
        </v-chip>
      </template>

      <template v-slot:item.client="{ item }">
       <span v-if="item.guest.first_name.length > 2 || item.guest.last_name.length > 2"
             style="cursor: pointer"
             @click="$router.push({'name' : 'viewGuest', params : {id :  item.guest.id}})">{{item.guest.first_name}} {{item.guest.last_name}}
       </span>
          <br>
        <v-chip
          v-if="item.guest.phone"
          style="color: white"
          class="ma-2"
          color="green"
        >
          {{ item.guest.phone }}
        </v-chip>

      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify justify-space-around">
          <v-btn color="primary" fab x-small @click="$router.push({'name' : 'editReservation',
       params : { restaurantId : item.restaurant.id,  reservationId : item.id}})"  dark title="Редактирование">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="blue"
                 @click="$router.push({'name' : 'viewReservation', params : {id : item.id, restaurantId : item.restaurant.id}})"
                 fab
                 x-small
                 dark
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-btn color="red" fab  x-small dark title="Удалить" @click="deleteReservation(item.id)">
            <v-icon>mdi-delete-alert</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip
          style="color: white"
          class="ma-2"
          :color="item.status.color"
        >
          {{ item.status.name }}
        </v-chip>
      </template>
      <template v-slot:item.date_time_visit="{ item }">
        {{item.date_time_visit}}
      </template>
      <template v-slot:item.notes="{ item }">
        <v-chip
          v-if="item.notes"
          style="color: white"
          class="ma-2"
          color="red"
        >
          {{ item.notes.substr(0 , 14)  }} <span v-if="item.notes.length > 14">...</span>
        </v-chip>
      </template>
      <template v-slot:item.count_person="{ item }">
        <v-chip
          style="color: white; max-width: 100px"
          class="ma-2"
          color="warning"
        >
          {{ item.count_person }}
        </v-chip>
      </template>
    </v-data-table>
    <div class="text-center" v-if="lastPage > 1">
      <v-pagination
        v-model="page"
        :length="lastPage"
        circle
      ></v-pagination>
    </div>
    <v-card-text style="height: 100px; position: relative" v-if="activeRestaurant">
      <v-fab-transition>
        <v-btn
          @click="createReservation()"
          title="Создать Бронь"
          color="blue"
          dark
          top
          absolute
          right
          fab
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card-text>
  </v-container>
</template>

<script>
  import CreateReservation from "./CreateReservation";
  import FilterApp from './Filter'
  import {fabric} from "fabric-with-gestures";
  import Querystring from 'querystring'

  export default {
    props:{
      restaurantId : {
        type : [String, Number]
      }
    },
    components: {
      FilterApp,
    },
    mounted() {
      if(this.restaurantId){
        this.setActiveRestaurant(this.restaurantId)
      }
      this.$store.dispatch('restaurants/loadRestaurants');
    },
    data: () => ({
      page : 1,
      lastPage : 1,
      dialog: false,
      activeRestaurant: null,
      filter: {},
      reservations : [],
      headers: [
        {
          text: 'Столы ',
          align: 'start',
          sortable: false,
          value: 'tablesNumber',
        },
        {
          text: 'Клиент ',
          align: 'start',
          sortable: false,
          value: 'client',
        },
        {
          text: 'Статус ',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Дата визита ',
          align: 'start',
          sortable: false,
          value: 'date_time_visit',
        },
        {
          text: 'Кол-во гостей ',
          align: 'start',
          sortable: false,
          value: 'count_person',
        },
        {
          text: 'Примечания ',
          align: 'center',
          sortable: false,
          value: 'notes',
        },
        { text: 'Actions', value: 'actions', sortable: false,   align: 'center', },
      ],
    }),

    computed: {
      restaurants() {
        return this.$store.getters['restaurants/getRestaurants']
      },
    },
    watch : {
      activeRestaurant(){
        this.loadReservation();
      },
      page(){
        this.loadReservation();
      },
      'filter' : {
        deep : true,
        handler(){
          this.page = 1;
          this.loadReservation();
        }
      }
    },
    methods: {
      setActiveRestaurant(restaurantId){
        this.activeRestaurant = restaurantId;
        this.$router.push({name: 'listReservationForRestaurant', params: {restaurantId: this.activeRestaurant} , query : this.filter})
      },
      agreeDelete(data){
        axios.delete('reservation/'+this.activeRestaurant+'/'+data.id)
        .then(() => {
          this.loadReservation();
        });
      },
      deleteReservation(id){
        bus.$emit('modalAgree', {
          text : 'Если вы удалите ресторан, то удалится вся информация о нём, в том числи и все резервы. Вы согласны ?',
          callback : this.agreeDelete,
          params : {
            id : id
          }
        })
      },
      loadReservation(){
        let data = this.filter;
        data.page  = this.page
        axios.post('reservation/'+this.activeRestaurant, this.filter)
        .then(({data}) => {
          this.reservations = data.data;
          this.page = data.meta.current_page
          this.lastPage = data.meta.last_page
        });
      },
      changeFilter(value) {
        this.filter = value;
        console.log(this.filter);
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+Querystring.stringify(this.filter);
        window.history.pushState({path:newurl},'',newurl);
      },
      createReservation() {
        this.$router.push({name: 'createReservation', params: {restaurantId: this.activeRestaurant}})
      }
    },
  }
</script>


<style>
  .v-data-table__mobile-row {
    height: auto !important;
  }
</style>
